import {Component, OnInit} from '@angular/core';
import {Observable} from "rxjs";
import {ApiService, TenantListItem, UserListItem} from "../../../services/api.service";
import {DeleteButtonComponent} from "../../../core/delete-button/delete-button.component";
import {ManageButtonComponent} from "../../../core/manage-button/manage-button.component";
import {PreviewButtonComponent} from "../../../core/preview-button/preview-button.component";
import {QuickDashboardComponent} from "../../../core/quick-dashboard/quick-dashboard.component";

@Component({
  selector: 'app-users-list',
  standalone: true,
  imports: [
    DeleteButtonComponent,
    ManageButtonComponent,
    PreviewButtonComponent,
    QuickDashboardComponent
  ],
  templateUrl: './users-list.component.html'
})
export class UsersListComponent  implements OnInit {

  readonly now = new Date()
  loader?: Observable<UserListItem[]>

  constructor(
    readonly api: ApiService,
  ) {
  }

  ngOnInit(): void {
    this.loader = this.api.getUsers()
  }
}
